export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/access/index.js